import { ref, computed } from 'vue'

/**
 * Composable for managing chart drill-down state.
 * Handles navigation between overview, teams, employees, derden, and pipeline levels.
 */
export function useChartDrilldown() {
  const drilldownLevel = ref('overview') // 'overview' | 'teams' | 'employees' | 'derden' | 'pipeline'
  const drilldownTeam = ref(null)
  const drilldownPipelineCategory = ref(null) // 'leads_verkenningen' | 'prospects' | 'sourcing'

  const chartTitle = computed(() => {
    switch (drilldownLevel.value) {
      case 'pipeline':
        if (drilldownPipelineCategory.value === 'leads_verkenningen') return 'Leads — per kans'
        if (drilldownPipelineCategory.value === 'sourcing') return 'Sourcing — per kans'
        return 'Prospects — per kans'
      case 'derden':
        return 'Derden Prognose per Omzetgroep'
      case 'employees':
        return `Billable omzet — ${drilldownTeam.value?.team_name}`
      case 'teams':
        return 'Billable omzet per Afdeling'
      default:
        return 'Omzetprognose'
    }
  })

  const chartSubtitle = computed(() => {
    switch (drilldownLevel.value) {
      case 'pipeline':
        return 'Gewogen omzet per kans, uitgespreid over looptijd'
      case 'derden':
        return 'Vaste-prijs omzet uitgesplitst per omzetgroep per maand'
      case 'employees':
        return 'Billable omzet per medewerker per maand'
      case 'teams':
        return 'Billable omzet per team per maand (klik op team voor details)'
      default:
        return 'De realisatie en prognose van de uren en derdenomzet.'
    }
  })

  function goBack() {
    switch (drilldownLevel.value) {
      case 'employees':
        drilldownTeam.value = null
        drilldownLevel.value = 'teams'
        break
      case 'teams':
      case 'derden':
      case 'pipeline':
        drilldownTeam.value = null
        drilldownPipelineCategory.value = null
        drilldownLevel.value = 'overview'
        break
    }
  }

  return {
    drilldownLevel,
    drilldownTeam,
    drilldownPipelineCategory,
    chartTitle,
    chartSubtitle,
    goBack
  }
}
